export const nonNullable = <T>(
  maybe: T | null | undefined | string | boolean
): maybe is T => {
  return Boolean(maybe);
};
